import { APP_CONSTANTS } from "../constants/constants";

export function getOperator(operatorText: string): string {
  switch (operatorText.toLowerCase()) {
    case APP_CONSTANTS.MORE_THAN:
      return ">";
    case APP_CONSTANTS.LESS_THAN:
      return "<";
    case APP_CONSTANTS.EQUAL:
      return "==";
    case APP_CONSTANTS.NOT_EQUAL:
      return "!=";
    case APP_CONSTANTS.MORE_THAN_OR_EQUAL:
      return ">=";
    case APP_CONSTANTS.LESS_THAN_OR_EQUAL:
      return "<=";
    default:
      throw new Error(`Unknown operator: ${operatorText}`);
  }
}

export function compareValues(a: number, b: number, operator: string): boolean {
  if (operator === 'morethan') return a > b;
  if (operator === 'lessthan') return a < b;
  if (operator === 'equal') return a == b;
  if (operator === 'notequal') return a != b;
  if (operator === 'morethanorequal') return a >= b;
  if (operator === 'lessthanorequal') return a <= b;
  return false; // fallback
}
